import React, { useState } from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';
import type { Event } from '../../../api/types';
import ChecklistTab from './ChecklistTab';
import FilesTab from './FilesTab';

interface SectionProps {
  title: string;
  defaultOpen?: boolean;
  children: React.ReactNode;
}

function Section({ title, defaultOpen = true, children }: SectionProps) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div>
      <button
        onClick={() => setOpen(v => !v)}
        style={{
          display: 'flex', alignItems: 'center', gap: '0.5rem',
          background: 'none', border: 'none', cursor: 'pointer',
          padding: '0.25rem 0', marginBottom: open ? '0.875rem' : 0,
          width: '100%', textAlign: 'left',
          color: 'var(--color-text)',
        }}
      >
        {open ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
        <span style={{ fontSize: 'var(--text-md)', fontWeight: 700 }}>{title}</span>
      </button>
      {open && children}
    </div>
  );
}

export default function FilesAndNotesTab({ event }: { event: Event }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '2rem' }}>
      <Section title="Checklist">
        <ChecklistTab event={event} />
      </Section>
      <Section title="File & Note">
        <FilesTab event={event} />
      </Section>
    </div>
  );
}
